import { render, staticRenderFns } from "./ResultsOnlyWorkspace.vue?vue&type=template&id=675c082a&scoped=true"
import script from "./ResultsOnlyWorkspace.vue?vue&type=script&lang=js"
export * from "./ResultsOnlyWorkspace.vue?vue&type=script&lang=js"
import style0 from "./ResultsOnlyWorkspace.vue?vue&type=style&index=0&id=675c082a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c082a",
  null
  
)

export default component.exports